import { PrimaryButton } from "Components/Shared/Buttons/PrimaryButton";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  isLoading: boolean;
  onClick: () => void;
};

export const CancelTransactionButton = ({ isLoading, onClick }: Props) => {
  const { t } = useResource();

  return (
    <PrimaryButton
      variant="outlined"
      color="error"
      fullWidth
      onClick={onClick}
      disabled={isLoading}
    >
      {isLoading
        ? t(Resources.Dashboard.Loading)
        : t(Resources.Transactions.CancelTransaction)}
    </PrimaryButton>
  );
};
